import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import theme from 'site-react/theme';

const linkGroupStyle = css`
  background-color: ${theme.colors.white};
  border-top: 1px solid ${theme.colors.neutral100};
`;

const MobileNavLinkGroup = ({ children }) => (
  <div className={linkGroupStyle}>{children}</div>
);

MobileNavLinkGroup.propTypes = {
  /**
   * Links to show in this group
   */
  children: PropTypes.node,
};

export default MobileNavLinkGroup;
